import { experienceEvent } from 'analytics/snowplow/events'
import type { ExperienceEventDefinitionKey, ExperienceEventEntity } from 'analytics/snowplow/helpers'
import GeoContext from 'contexts/geoContext'
import { useCallback, useContext } from 'react'
import { trackEvent } from 'analytics/analytics'

/**
 * This hooks returns a function that allows you to track some experience offer analytic event and enrich
 * it with the current snapshot of the offer state, without waiting for the next re-render.
 *
 * ```
 * const trackExperienceOfferEvent = useTrackExperienceOfferEvent(...)
 *
 * const someHandler = () => {
 *     dispatch({ type: 'STATE_UPDATE' })
 *     trackExperienceOfferEvent('EVENT')
 * }
 *
 * ```
 * @returns A tracking function
 */

function useTrackExperienceOfferEvent() {
  const geo = useContext(GeoContext)
  const trackExperienceOfferEvent = useCallback((eventKey: ExperienceEventDefinitionKey, eventEntities?: Array<ExperienceEventEntity>) => {
    trackEvent(experienceEvent(eventKey, geo, eventEntities))
  }, [geo])

  return trackExperienceOfferEvent
}

export default useTrackExperienceOfferEvent
